import { useEffect, useState } from 'react';

const useOnScree2 = (ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ref.current) return;

      const rect = ref.current.getBoundingClientRect();
      const screenHeight = window.innerHeight;

      const topLimit = screenHeight * 0.1;
      const bottomLimit = screenHeight * 0.9;

      const elementTop = rect.top;
      const elementBottom = rect.bottom;
      // Kiểm tra nếu phần tử nằm trong khoảng 30% - 70% của màn hình
      if (elementBottom >= topLimit && elementTop <= bottomLimit) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Kiểm tra ban đầu

    return () => window.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return isVisible;
};

export default useOnScree2;
